import { createEffect } from 'effector'

export const changeTabFx = createEffect((tab: number) => {
  return tab
})

export const toggleScrollAllowanceFx = createEffect((state: boolean) => {
  return state
})

export const changeNavVisibilityFx = createEffect((state: boolean) => {
  return state
})
export const smoothNavbarVisibilityFx = createEffect((state: boolean) => {
  return state
})
